module.exports = __webpack_public_path__ + "static/img/product_map.831f5bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_map.jpg
// module id = 70hM
// module chunks = 0